import { SelectOption as Option } from 'components/select/types';
import { Brand } from 'models/brands';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useAppStore } from 'hooks/state/useAppStore';
import { useTransitiveCacheStore } from 'hooks/state/useTransitiveCacheStore';
import { BaseSelect } from '../../BaseSelect';

interface BrandSelectProps {
  selectedBrands?: string[];
  setSelectedBrands?: (value: string[]) => void;
  className?: string;
  showConfirmButton?: boolean;
  disabled?: boolean;
}

const mapBrandToBrandOption = (brand: Brand): Option<string> => ({
  id: brand.id,
  value: brand.id,
  label: brand.label,
  logo: brand.logo,
});

export function BrandSelect({
  selectedBrands = undefined,
  setSelectedBrands = undefined,
  className = undefined,
  showConfirmButton = false,
  disabled = false,
}: BrandSelectProps) {
  const { allBrands } = useTransitiveCacheStore();

  const { brands, setBrands } = useAppStore();
  const { disabledFilters } = useTransitiveCacheStore();

  const allBrandOptions = useMemo(() => allBrands.map(mapBrandToBrandOption), [allBrands]);
  const intl = useIntl();

  return (
    <BaseSelect
      id="brand-filter"
      className={className}
      label={intl.formatMessage({
        id: 'filter.key.selectedBrands',
        defaultMessage: 'Brands',
      })}
      selectedItems={selectedBrands ?? brands ?? []}
      allOptionItems={allBrandOptions}
      setSelectedItems={setSelectedBrands ?? setBrands}
      showConfirmButton={showConfirmButton}
      disabled={disabled || disabledFilters.includes('prdBrand')}
    />
  );
}
